import {Rating} from '@mui/material';
import React, {useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import starIcon from '../../../../assets/medico-online/Star.png';
import noPhotoDoctor from '../../../../assets/medico_sem_foto.png';
import starEmptyBorder from '../../../../assets/star-empty-border.png';
import {Column, Row} from '../../../../components/layout';
import {addToWizard} from '../../../../store/actions';
import * as fonts from '../../../../util/fonts';
import {strings} from '../../../../util/strings';
import './styles.scss';
import ArrowRight from '../../../../components/arrow-right-icon/ArrowRight';
import {Doctor} from '../schedule-appointments/speciality-select/components/doctor-filter/DoctorFilter';

export interface DoctorsResultListProps {
  buStyles: any;
  labels: typeof strings.pt.appointments;
  borderColor?: any;
  nextStep?: Function;
  addToWizard(value: any): void;
  doctorsFound: Doctor[];
  setDoctorsFound: Function;
  setShowNoDoctorsFound: Function;
  setIsLoading: Function;
  setShowDayTime: Function;
  setSelectedDoctor: Function;
  handleOnDoctorClick(doctor: any): void;
}

function DoctorsResultList({
  buStyles,
  labels,
  doctorsFound,
  setDoctorsFound,
  setShowNoDoctorsFound,
  setIsLoading,
  borderColor,
  nextStep,
  addToWizard,
  handleOnDoctorClick,
  setSelectedDoctor,
  setShowDayTime,
}: DoctorsResultListProps) {
  const loadNoPhotoDoctor = (event: any) => {
    event.target.src = noPhotoDoctor;
  };

  const resultsTitle = () => {
    const resultsString =
      doctorsFound?.length > 0
        ? `${(doctorsFound?.length).toString().padStart(2, '0')} ${
            labels?.appointments_scheduleByDoctorSearchResults
          }
          `
        : '';
    return resultsString.toUpperCase();
  };

  return (
    <>
      <Row className="doctors-result-list-container">
        <span
          style={{
            ...fonts.S,
            ...fonts.SemiBold,
          }}
          className="doctors-result-title">
          {resultsTitle()}
        </span>
        {doctorsFound.map((doctor: Doctor) => (
          <>
            <Row
              className="doctors-result-list-row"
              onClick={() => {
                handleOnDoctorClick(doctor);
              }}>
              <Column
                className="appointment-doctor-column1"
                style={{...fonts.MM}}>
                <img
                  src={doctor.photo.normal}
                  onError={loadNoPhotoDoctor}
                  className="doctor-imgs"
                  style={{border: `1px solid ${buStyles.primaryColor}`}}
                />
              </Column>
              <Column className="appointment-doctor-column2">
                <span
                  style={{
                    ...fonts.M,
                    ...fonts.SemiBold,
                  }}>
                  {doctor.name}
                </span>
                <span style={{...fonts.SM}}>
                  {doctor?.specialties?.[0]?.name}
                </span>
                <Rating
                  className="ratings"
                  defaultValue={parseFloat(doctor?.rating || '0') / 2}
                  precision={0.01}
                  readOnly
                  icon={<img src={starIcon} width={10} />}
                  emptyIcon={<img src={starEmptyBorder} width={10} />}
                />
              </Column>

              <Column className="doctors-result-list-arrow">
                <ArrowRight color={buStyles?.primaryColor} />
              </Column>
            </Row>
          </>
        ))}
      </Row>
    </>
  );
}

const mapStateToProps = ({globalStyles, strings}: any) => ({
  buStyles: globalStyles.value,
  labels: strings.value.pt.appointments,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(DoctorsResultList)
);
